import { render } from "./AssetManagerLite.vue?vue&type=template&id=715f02a3"
import script from "./AssetManagerLite.vue?vue&type=script&lang=js"
export * from "./AssetManagerLite.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__